import { createFileRoute, redirect } from "@tanstack/react-router";
import { PublicEventPage } from "@/features/event-explorer/components/PublicEventPage";
import { getApiErrorStatus } from "@/lib/apiErrors";
import { authApi } from "@/lib/humhub-api/auth";
import { eventsApi } from "@/lib/humhub-api/events";

export const Route = createFileRoute("/public-event/$event-code")({
  beforeLoad: async ({ params }) => {
    const code = params["event-code"];

    // イベント情報を取得
    let event: Awaited<
      ReturnType<typeof eventsApi.getPublicEventByCode>
    > | null = null;
    try {
      event = await eventsApi.getPublicEventByCode(code);
    } catch (error) {
      if (getApiErrorStatus(error) === 404) {
        throw redirect({ to: "/not-found", replace: true });
      }
      throw error;
    }
    if (!event?.id) {
      throw redirect({ to: "/not-found", replace: true });
    }

    // 未ログインは公開ページの正常系として扱い、ログイン済みだけ内部ページへ送る
    const me = await authApi.getCurrentUserOrNull();
    if (me) {
      window.location.replace(`/event-search/code/${event.code}`);
      return;
    }
  },

  loader: async ({ params }) => {
    const code = params["event-code"];
    return { eventCode: code };
  },

  staleTime: 0,
  component: PublicEventPage,
});
